import React, { useState } from 'react';
import { Form, Row, Col, Select, Input, Button, Typography } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import '../Common/Form.css';
import './QuestionForm.css';
import { renderConditionalOptions } from '../../utilities/formHelpers';

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 },
  },
};
const formItemLayoutWithOutLabel = {
  wrapperCol: {
    xs: { span: 24, offset: 0 },
    sm: { span: 20, offset: 4 },
  },
};

const { Text } = Typography;

const QuestionForm = (props) => {
  const { initialValues, onSubmit, status, type } = props;

  const [questionType, setQuestionType] = useState('');

  const changeQuestionType = (value) => {
    setQuestionType(value);
  };

  return (
    <div className="question-form">
      <Form
        labelCol={{ span: 7 }}
        wrapperCol={{ span: 21 }}
        onFinish={onSubmit}
        initialValues={initialValues}
      >
        <Form.Item
          label="Type"
          name="type"
          rules={[{ required: true, message: 'Please input type!' }]}
        >
          <Select onChange={changeQuestionType}>
            <Select.Option value="rating">Rating</Select.Option>
            <Select.Option value="number">Number</Select.Option>
            <Select.Option value="string">String</Select.Option>
            <Select.Option value="dropDown">Dropdown</Select.Option>
            <Select.Option value="multiAnswerDropdown">
              Multi-answer dropdown
            </Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Question"
          name="question"
          rules={[{ required: true, message: 'Please input question!' }]}
        >
          <Input />
        </Form.Item>

        {questionType === 'dropDown' ||
        questionType === 'multiAnswerDropdown' ? (
          <section>
            <Text>
              <span className="required-sign">*</span> Answer options
            </Text>
            <div style={{ marginTop: '10px' }}>
              <Form.List
                name="options"
                rules={[{ required: true, message: 'Please add options' }]}
              >
                {(fields, { add, remove }) => (
                  <>
                    {fields.map((field, index) => (
                      <Form.Item
                        {...(index === 0
                          ? formItemLayout
                          : formItemLayoutWithOutLabel)}
                        label={`Option ${index + 1}`}
                        required={true}
                        key={field.key}
                      >
                        <Form.Item
                          {...field}
                          validateTrigger={['onChange', 'onBlur']}
                          rules={[
                            { required: true, message: 'Missing option' },
                          ]}
                          noStyle
                        >
                          <Input placeholder="option" />
                        </Form.Item>
                        {fields.length > 1 ? (
                          <MinusCircleOutlined
                            className="dynamic-delete-button"
                            onClick={() => remove(field.name)}
                          />
                        ) : null}
                      </Form.Item>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        style={{ width: '60%' }}
                        icon={<PlusOutlined />}
                      >
                        Add option
                      </Button>
                      <Button
                        type="dashed"
                        onClick={() => {
                          add('', 0);
                        }}
                        style={{ width: '60%', marginTop: '20px' }}
                        icon={<PlusOutlined />}
                      >
                        Add option before
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </div>
          </section>
        ) : null}

        {questionType === 'rating' && (
          <Form.Item
            label="Is Overall Rating?"
            name="tag"
            rules={[
              {
                required: false,
                message: 'Please input if question is overall rating!',
              },
            ]}
          >
            <Select>{renderConditionalOptions()}</Select>
          </Form.Item>
        )}

        {status.type === 'ERROR' ? (
          <Text type="danger">{status.message}</Text>
        ) : null}
        {status.type === 'SUCCESS' ? (
          <Text type="success">Successfully Updated!</Text>
        ) : null}
        <Row justify="end" gutter={12}>
          <Col>
            <Button type="primary" htmlType="submit">
              {type}
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default QuestionForm;
